import { Button } from "antd";
import AntIcon from "../wrappers/AntIcon";

const NavbarIconButton = ({ iconPath, onClick }) => {
  return (
    <div className="w-10 bell-button">
      <Button
        block
        size="large"
        type="text"
        icon={<AntIcon iconPath={iconPath} />}
        onClick={onClick}
        className="border-[#E8E8E8] border-1 rounded-md inline-block"
      />
    </div>
  );
};

export default NavbarIconButton;
